import { styled } from 'styled-components';

export const WrapperBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 24px 0;
  @media (max-width: 768px) {
    margin: 12px 0;
  }
`;
